import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip } from 'antd';

import * as customersActions from '~/_domains/customers/drawer/actions';
import { PERMISSIONS } from '~/constants/permissions.constants';

/**
 * Nome do cliente que abre o cadastro dele ali mesmo, no drawer, sem sair do
 * relatório. Levar para /clientes obrigava a procurar o cliente de novo na
 * carteira e perdia a posição na lista da campanha.
 *
 * A página precisa montar o <CustomerForm /> (o drawer) — ele não é global.
 */
const ClienteLink = ({ id, nome }) => {
  const dispatch = useDispatch();
  const podeVer = useSelector(function (state) {
    return !!(state.user && state.user.permissions &&
      state.user.permissions.includes(PERMISSIONS.customers.view));
  });

  if (!id || !podeVer) return <span>{nome}</span>;

  return (
    <Tooltip title="Abrir o cadastro do cliente">
      <a onClick={function () { dispatch(customersActions.showDrawerCustomer({ id: id }, 'Campanhas')); }}>
        {nome}
      </a>
    </Tooltip>
  );
};

export default ClienteLink;
